export default {
  id: null,
  skills: [],
  questions: [],
}